// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { closeSessionGlobal } from "../commons/utils";


const http = new AxiosAdapter();



export const setCustomerService = async(customer:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/customer', customer, setPercentajeCCompany); 

    } catch (error) {
        console.log('tonkaaaaaaaaaaaaaaaaaa ',error)
    }
}






export const getAllCustomerService = async() => {
   
    try {

        return await http.get<any>(`/v1/customer`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('tonkaaaaaaaaaaaaaaaaaa getAllTipoNovedadService ',error)
    }
}



export const getAllCustomerByParamService = async(param:number) => {
   
    try {

        return await http.get<any>(`/v1/customer/search/${param}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('tonkaaaaaaaaaaaaaaaaaa getAllTipoNovedadService ',error)
    }
}



export const getAllCustomerByPaginateService = async(page:number) => {
   
    try {

        return await http.get<any>(`/v1/customer?page=${page}&take=10`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('tonkaaaaaaaaaaaaaaaaaa getAllCustomerByPaginateService ',error)
    }
}



export const createTipoNovedadService = async(tipoNovedad:object, setPercentajeCreateTurno:any) => {
   
    try {

        return await http.post<any>(`/v1/type-news`, tipoNovedad, setPercentajeCreateTurno); 

    } catch (error:any) {

        if( error.code === 403 ){
            
            await closeSessionGlobal(); 
            window.location.href = '/';

        }
        console.log('createParameterService ',error)
    }
}



export const desactiveCustomerService = async(customerId: string) => {
   
    try {


        return await http.delete<any>(`/v1/customer/${customerId}`); 

    } catch (error:any) {


        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('desactiveCustomerService ',error)
    }
}



export const activeCustomerService = async(customerId: string) => {
   
    try {

        return await http.patch<any>(`/v1/customer/${customerId}`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('activeCustomerService ',error);
    }
}



export const getDetailCustomerService = async(customerId:string) => {
   
    try {

        return await http.get<any>(`/v1/customer/${customerId}`); 

    } catch (error:any) {

        
        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('getDetailCustomerService ',error);
    }
}






export const updateCustomerService = async(customer: object) => {
   
    try {

        return await http.put<any>(`/v1/customer`, customer); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }

        console.log('updateCustomerDetailService ',error);

    }
}